export default "__VITE_ASSET__eef8b08e__"